import { render, staticRenderFns } from "./actionRemarks.vue?vue&type=template&id=5bb9d160&scoped=true&"
import script from "./actionRemarks.vue?vue&type=script&lang=js&"
export * from "./actionRemarks.vue?vue&type=script&lang=js&"
import style0 from "./actionRemarks.vue?vue&type=style&index=0&id=5bb9d160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb9d160",
  null
  
)

export default component.exports